module.exports = __webpack_public_path__ + "img/about.c30541f1.png";